import axios, { AxiosInstance, AxiosResponse } from 'axios';

import { getSearchParamsAsObject, isLidlUSDomain } from '../helper/js/helper';

const { VITE_API_URL, VITE_API_VERSION, VITE_ENV, VITE_CMS_URL, VITE_API_BASE_URL_LIDL_US } =
  import.meta.env;

export const leafletCMS = (): AxiosInstance =>
  axios.create({
    baseURL: `${VITE_CMS_URL}/`,
  });

export const leafletAPI = (): AxiosInstance => {
  let baseURL = `${VITE_API_URL}/${VITE_API_VERSION}`;
  const isUSDomain = isLidlUSDomain();

  if (isUSDomain) {
    baseURL = `${VITE_API_BASE_URL_LIDL_US}/${VITE_API_VERSION}`;
  }

  if (VITE_ENV !== 'production' && !isUSDomain) {
    // to test new api features, it is possible to override the api baseUrl on non-prod envs
    const { apiUrl = VITE_API_URL, apiVersion = VITE_API_VERSION } = getSearchParamsAsObject();
    baseURL = `${decodeURIComponent(apiUrl)}/${apiVersion}`;
    console.info(`API URL has been set to ${baseURL} :-)`);
  }

  return axios.create({ baseURL });
};

export const cartAPI = (): AxiosInstance =>
  axios.create({
    baseURL: '/cart-api/',
  });

export const productAPI = (): AxiosInstance => {
  return axios.create({
    baseURL: `/p/api/`,
  });
};

export function checkResponse(response: AxiosResponse, property?: string): boolean {
  if (response?.data.success && (!property || response.data[property])) {
    return true;
  }
  throw new Error('API RESPONSE INVALID');
}
